import { render } from "./SectionPaymentLiquidation.vue?vue&type=template&id=2c680bd5&scoped=true"
import script from "./SectionPaymentLiquidation.vue?vue&type=script&lang=js"
export * from "./SectionPaymentLiquidation.vue?vue&type=script&lang=js"

import "./SectionPaymentLiquidation.vue?vue&type=style&index=0&id=2c680bd5&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c680bd5"]])

export default __exports__